import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=1374bb98"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=1374bb98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports